// @flow
import * as React from 'react';
import InfoBox from 'components/InfoBox';
import { FormContextConsumer } from './FormContext';

const GeneralError = ({
  match,
  ignore
}: {
  match?: string,
  ignore?: Array<?string>
}) => (
  <FormContextConsumer>
    {({ errors }) => {
      const error = errors[''] || errors.general;
      if (
        !error ||
        (match && error !== match) ||
        (ignore && ignore.includes(error))
      ) {
        return null;
      }
      return (
        // className used to scroll to error
        <InfoBox className="error" type="danger" mb={4}>
          {error}
        </InfoBox>
      );
    }}
  </FormContextConsumer>
);

export default GeneralError;
